'use strict';

var isObject = require('../../../../motion-utils/dist/es/is-object.cjs');

/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */
function isHTMLElement(element) {
    return isObject.isObject(element) && "offsetHeight" in element;
}

exports.isHTMLElement = isHTMLElement;
//# sourceMappingURL=is-html-element.cjs.map
